import React from "react";
import { LuAlertCircle, LuCheck, LuX } from "react-icons/lu";

// Shared by the support pages (customer support, subscription update)

export const card = "rounded-2xl border border-gray-200 bg-white p-5 shadow-sm sm:p-6";
export const field = "block w-full rounded-xl border border-gray-200 bg-white px-3.5 py-2.5 text-sm text-gray-900 placeholder:text-gray-400 shadow-sm transition focus:border-gray-900 focus:outline-none focus:ring-4 focus:ring-gray-900/10";
export const primaryButton = "inline-flex items-center justify-center gap-2 rounded-xl bg-primary px-4 py-2.5 text-sm font-medium text-white shadow-sm transition hover:bg-secondary focus:outline-none focus:ring-4 focus:ring-gray-900/20 active:scale-[0.98] disabled:pointer-events-none disabled:opacity-50";

export function StepHeader({ step, title, description }) {
  return (
    <div className="mb-4 flex items-start gap-3">
      <span className="flex h-7 w-7 flex-none items-center justify-center rounded-full bg-gray-900 text-xs font-semibold text-white">
        {step}
      </span>
      <div>
        <h2 className="text-base font-semibold text-gray-900">{title}</h2>
        {description && <p className="mt-0.5 text-sm text-gray-500">{description}</p>}
      </div>
    </div>
  );
}

export function Guarantee({ icon: Icon, children }) {
  return (
    <span className="inline-flex items-center gap-1.5 rounded-full border border-gray-200 bg-white px-3 py-1 text-xs font-medium text-gray-600">
      <Icon className="h-3.5 w-3.5" aria-hidden="true" />
      {children}
    </span>
  );
}

export function AccountOption({ account, selected, onSelect }) {
  const initial = (account.name || account.accountId || '?').charAt(0).toUpperCase();
  return (
    <button
      type="button"
      role="radio"
      aria-checked={selected}
      onClick={() => onSelect(account)}
      className={`flex w-full items-center gap-3 rounded-xl border px-4 py-3 text-left transition focus:outline-none focus-visible:ring-4 focus-visible:ring-gray-900/10 ${selected
        ? 'border-gray-900 bg-gray-50 ring-1 ring-gray-900'
        : 'border-gray-200 hover:border-gray-300 hover:bg-gray-50'}`}
    >
      <span className="flex h-9 w-9 flex-none items-center justify-center rounded-lg bg-gray-900 text-sm font-semibold text-white">
        {initial}
      </span>
      <span className="min-w-0 flex-1">
        <span className="block truncate text-sm font-medium text-gray-900">{account.name || 'Unnamed account'}</span>
        <span className="block truncate font-mono text-xs text-gray-500">{account.accountId}</span>
      </span>
      {account.status && (
        <span className="hidden rounded-full bg-gray-100 px-2 py-0.5 text-xs font-medium text-gray-600 sm:inline">
          {account.status}
        </span>
      )}
      <span className={`flex h-5 w-5 flex-none items-center justify-center rounded-full border ${selected
        ? 'border-gray-900 bg-gray-900 text-white'
        : 'border-gray-300'}`}>
        {selected && <LuCheck className="h-3 w-3" aria-hidden="true" />}
      </span>
    </button>
  );
}

export function ErrorAlert({ message, onDismiss }) {
  return (
    <div role="alert" className="flex items-start gap-3 rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700 dark:border-red-900/60 dark:bg-red-950/40 dark:text-red-300">
      <LuAlertCircle className="mt-0.5 h-4 w-4 flex-none" aria-hidden="true" />
      <span className="flex-1">{String(message)}</span>
      <button type="button" onClick={onDismiss} aria-label="Dismiss" className="rounded p-0.5 hover:bg-red-100 dark:hover:bg-red-900/40">
        <LuX className="h-4 w-4" aria-hidden="true" />
      </button>
    </div>
  );
}
